import { createSelector } from 'reselect';
import { getUser } from '../auth/selectors';

export const getAdminState = (state) => state.admin || [];

export const getAdmins = createSelector(getAdminState, (admin) => admin.admins);
export const getUsers = createSelector(getAdminState, (admin) => admin.users);
export const usersLoading = createSelector(
    getAdminState,
    (admin) => admin.usersLoading,
);
export const usersRemoving = createSelector(
    getAdminState,
    (admin) => admin.userRemoving,
);
export const usersRemovingError = createSelector(
    getAdminState,
    (admin) => admin.userRemovingError,
);
export const usersAdding = createSelector(
    getAdminState,
    (admin) => admin.userAdding,
);
export const usersAddError = createSelector(
    getAdminState,
    (admin) => admin.userAddError,
);

export const getAdminsLoading = createSelector(
    getAdminState,
    (admin) => admin.adminsLoading,
);

export const getDeleteAdminID = createSelector(
    getAdminState,
    (admin) => admin.deletedAdmin,
);

export const getAddAdminEmail = createSelector(
    getAdminState,
    (admin) => admin.addAdmin,
);

export const getCitizenScientist = createSelector(
    getAdminState,
    (admin) => admin.scientist,
);
export const getCitizenScientistLoading = createSelector(
    getAdminState,
    (admin) => admin.loadingScientist,
);

export const getCitizenScientistEmail = createSelector(
    getAdminState,
    (admin) => admin.addScientist,
);

export const getDeletedScientistID = createSelector(
    getAdminState,
    (admin) => admin.deletedScientist,
);

export const getChildPartnerTypeKey = createSelector(
    getAdminState,
    (admin) => admin.partnerTypeKey,
);

export const getChildInspirePartners = createSelector(
    getAdminState,
    (admin) => admin.childInspirePartners,
);

export const getChildInspirePartnersLoading = createSelector(
    getAdminState,
    (admin) => admin.loadingChildInspirePartners,
);

export const getChildCampusPartners = createSelector(
    getAdminState,
    (admin) => admin.childCampusPartners,
);

export const getChildCampusPartnersLoading = createSelector(
    getAdminState,
    (admin) => admin.loadingChildCampusPartners,
);

export const getChildId = createSelector(
    getAdminState,
    (admin) => admin.childId,
);

export const getChildType = createSelector(
    getAdminState,
    (admin) => admin.childType,
);

export const getChildAdminEmail = createSelector(
    getAdminState,
    (admin) => admin.childEmail,
);

export const getRemoveChildId = createSelector(
    getAdminState,
    (admin) => admin.removeChildId,
);

export const getRemoveChildAdminId = createSelector(
    getAdminState,
    (admin) => admin.removeChildAdminId,
);

export const getPartnerDetails = createSelector(
    getAdminState,
    (admin) => admin.partnerDetails,
);

export const getaddAdminRequested = createSelector(
    getAdminState,
    (admin) => admin.addAdminRequested,
);
export const getAddScientistRequested = createSelector(
    getAdminState,
    (admin) => admin.addScientistRequested,
);
export const getAddChildAdminRequested = createSelector(
    getAdminState,
    (admin) => admin.addChildAdminRequested,
);
export const getChildAdminRequestedId = createSelector(
    getAdminState,
    (admin) => admin.addChildAdminRequestedId,
);

export const getCreatePartnerRequested = createSelector(
    getAdminState,
    (admin) => admin.createPartnerRequested,
);

export const getDeleteUserRequested = createSelector(
    getAdminState,
    (admin) => admin.deleteUserRequested,
);

export const getChildAdminProgress = createSelector(
    getAdminState,
    (admin) => admin.updateChildPartnerInProgress,
);

// Error States

export const getAdminError = createSelector(
    getAdminState,
    (admin) => admin.error,
);

export const getdeleteAdminError = createSelector(
    getAdminState,
    (admin) => admin.deleteAdminError,
);

export const getAddAdminError = createSelector(
    getAdminState,
    (admin) => admin.addAdminError,
);
export const getAddAdminSuccess = createSelector(
    getAdminState,
    (admin) => admin.addAdminMessage,
);

export const getScientistError = createSelector(
    getAdminState,
    (admin) => admin.scientistError,
);

export const getAddScientistError = createSelector(
    getAdminState,
    (admin) => admin.scientistAddError,
);

export const getAddScientistSuccess = createSelector(
    getAdminState,
    (admin) => admin.scientistAddMessage,
);

export const getDeleteScientistError = createSelector(
    getAdminState,
    (admin) => admin.deleteScientistError,
);

export const getChildPartnerError = createSelector(
    getAdminState,
    (admin) => admin.childPartnerError,
);

export const getAddChildAdminErrorId = createSelector(
    getAdminState,
    (admin) => admin.InspireAdminErrorId,
);

export const getAddChildAdminError = createSelector(
    getAdminState,
    (admin) => admin.InspireAdminError,
);

export const getcreatePartnerError = createSelector(
    getAdminState,
    (admin) => admin.createPartnerError,
);

export const geterrorPartnerType = createSelector(
    getAdminState,
    (admin) => admin.errorPartnerType,
);

export const getRemoveChildAdminError = createSelector(
    getAdminState,
    (admin) => admin.removeChildAdminError,
);

export const getRemoveChildAdminErrorId = createSelector(
    getAdminState,
    (admin) => admin.removeChildAdminErrorId,
);

export const getPartnerId = createSelector(
    getUser,
    (user) => user.partnerId || user.partner.id,
);

export const getUserId = createSelector(getUser, (user) => user.id);
